import React, { useState } from 'react';

export default function Portfolio({ shopifyLinks, wpLinks, onSave }) {
  const [shopify, setShopify] = useState(shopifyLinks.join('\n'));
  const [wp, setWp]           = useState(wpLinks.join('\n'));
  const [saved, setSaved]     = useState(false);

  function handleSave() {
    const newShopify = shopify.split('\n').map(l => l.trim()).filter(Boolean);
    const newWp      = wp.split('\n').map(l => l.trim()).filter(Boolean);
    onSave(newShopify, newWp);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div>
      <div className="card">
        <span className="card-label">Shopify Portfolio (one link per line)</span>
        <textarea
          rows={8}
          value={shopify}
          onChange={e => setShopify(e.target.value)}
          placeholder="https://your-shopify-project.com"
        />
      </div>

      <div className="card">
        <span className="card-label">WordPress Portfolio (one link per line)</span>
        <textarea
          rows={10}
          value={wp}
          onChange={e => setWp(e.target.value)}
          placeholder="https://your-wordpress-project.com"
        />
      </div>

      <div className="save-row">
        <button className="btn-primary" onClick={handleSave}>Save portfolio</button>
        {saved && <span className="save-msg">Saved!</span>}
      </div>
    </div>
  );
}
